var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "patsnap-biz-workspace_folder_tree",
      style:
        "width: " +
        _vm.service.treeWidth +
        ";borderRadius: " +
        _vm.service.borderRadius,
    },
    [
      _vm.nodata
        ? _c(
            "div",
            { staticClass: "workspace_folder_tree__nodata" },
            [
              _c("PtIcon", {
                staticClass: "workspace_folder_tree__nodata-icon",
                attrs: { icon: "SolidNoDataTip" },
              }),
              _c("p", { staticClass: "workspace_folder_tree__nodata-tips" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("PtWorkspaceFolderTree.noData")) + " "
                ),
              ]),
            ],
            1
          )
        : _vm.loadingWorkspaces
        ? _c("PtIcon", {
            staticClass: "workspace_folder_tree__loading",
            attrs: { icon: "SolidLoadingBars" },
          })
        : [
            _c(
              "div",
              { staticClass: "workspace_folder_tree__left" },
              [
                _c(
                  "ElCollapse",
                  { attrs: { value: _vm.collapseActiveName } },
                  _vm._l(_vm.allWorkspaces, function (ref) {
                    var title = ref.title
                    var type = ref.type
                    var workspaces = ref.workspaces
                    return _c(
                      "ElCollapseItem",
                      {
                        key: type,
                        attrs: {
                          name: type,
                          disabled: !_vm.service.allowCollapse,
                        },
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [_vm._v(_vm._s(title))]),
                        ]),
                        _c(
                          "ul",
                          { staticClass: "workspace_folder_tree__workspace" },
                          _vm._l(workspaces, function (workspace) {
                            return _c(
                              "li",
                              {
                                key: workspace.space_id,
                                staticClass:
                                  "workspace_folder_tree__workspace-item",
                                class: {
                                  active:
                                    _vm.currentWorkspaceId ===
                                    workspace.space_id,
                                  "workspace_folder_tree__workspace-item--selected":
                                    _vm.selectedWsIdList.includes(
                                      workspace.space_id
                                    ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClickWorkspace(workspace)
                                  },
                                },
                              },
                              [
                                _c("PtIcon", {
                                  staticClass:
                                    "workspace_folder_tree__workspace-item__tick",
                                  attrs: { icon: "SolidTick" },
                                }),
                                _c("PtIcon", {
                                  staticClass:
                                    "workspace_folder_tree__workspace-item__icon",
                                  attrs: { icon: "Solid3D" },
                                }),
                                _c(
                                  "ElTooltip",
                                  {
                                    attrs: {
                                      placement: "top-start",
                                      "open-delay": 300,
                                      "visible-arrow": false,
                                      enterable: false,
                                      offset: "-30",
                                      "popper-class":
                                        "workspace-folder-tree-tooltip",
                                      content: _vm.service.isShowPatentCount
                                        ? workspace.space_name +
                                          " (" +
                                          _vm.kilo(
                                            workspace.total_patent_count
                                          ) +
                                          ")"
                                        : workspace.space_name,
                                      effect: "light",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "workspace_folder_tree__workspace-item__info",
                                      },
                                      [
                                        _c(
                                          "PtTextTruncate",
                                          { attrs: { tag: "span", lines: 1 } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(workspace.space_name) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _vm.service.isShowPatentCount
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "workspace_folder_tree__workspace-item__info-count",
                                              },
                                              [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.kilo(
                                                        workspace.total_patent_count
                                                      )
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ],
                      2
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "workspace_folder_tree__right" },
              [
                _vm.loadingFolders
                  ? _c("PtIcon", {
                      staticClass:
                        "workspace_folder_tree__loading workspace_folder_tree",
                      staticStyle: { fontSize: "32px" },
                      attrs: { icon: "SolidLoadingBars" },
                    })
                  : _c("PtVirtualTree", {
                      ref: "tree",
                      attrs: {
                        "node-key": "id",
                        "default-expand-all": _vm.service.defaultExpandAll,
                        "default-expand-keys": _vm.expendFolderIdList,
                        "item-class": "workspace_folder_tree__node",
                        "check-strictly": _vm.service.checkStrictly,
                        data: _vm.folderTree,
                        "item-size": 32,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "empty",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "workspace_folder_tree__node-nodata",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("PtWorkspaceFolderTree.noFolder")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var node = ref.node
                            var data = ref.data
                            var isExpand = ref.isExpand
                            var isChecked = ref.isChecked
                            var isShowExpandIcon = ref.isShowExpandIcon
                            var toggleNodeExpand = ref.toggleNodeExpand
                            var toggleCheck = ref.toggleCheck
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "workspace_folder_tree__item",
                                  style: {
                                    paddingLeft: (node.level - 1) * 20 + "px",
                                  },
                                },
                                [
                                  _vm.service.multipleFolder
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "workspace_folder_tree__item__checkbox",
                                        },
                                        [
                                          _c("PtIcon", {
                                            staticClass:
                                              "workspace_folder_tree__item__checkbox-icon",
                                            attrs: {
                                              icon: isChecked
                                                ? "SolidCheckboxOnNew"
                                                : "SolidCheckboxOffNew",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onSelectFolder({
                                                  node: node,
                                                  toggleCheck: toggleCheck,
                                                  isChecked: isChecked,
                                                })
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "workspace_folder_tree__item__icon",
                                    },
                                    [
                                      isShowExpandIcon
                                        ? _c("PtIcon", {
                                            staticClass:
                                              "item__icon parent-item",
                                            attrs: {
                                              icon: isExpand
                                                ? "SolidDropdownOpen"
                                                : "SolidDropdownRight",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return toggleNodeExpand(node)
                                              },
                                            },
                                          })
                                        : _c("PtIcon", {
                                            staticClass:
                                              "item__icon child-item",
                                            attrs: { icon: "SolidSmallDot" },
                                          }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "ElTooltip",
                                    {
                                      attrs: {
                                        placement: "top-start",
                                        "open-delay": 300,
                                        "visible-arrow": false,
                                        enterable: false,
                                        offset: "-30",
                                        "popper-class":
                                          "workspace-folder-tree-tooltip",
                                        content: _vm.service.isShowPatentCount
                                          ? data.folder_name +
                                            " (" +
                                            _vm.kilo(data.patent_count) +
                                            ")"
                                          : data.folder_name,
                                        effect: "light",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "workspace_folder_tree__item__content",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSelectFolder({
                                                node: node,
                                                toggleCheck: toggleCheck,
                                                isChecked: isChecked,
                                              })
                                            },
                                          },
                                        },
                                        [
                                          _c("PtIcon", {
                                            staticClass:
                                              "workspace_folder_tree__item__content-icon",
                                            attrs: {
                                              icon: data.folder_auto_update
                                                ? "SolidAutoFolder"
                                                : "SolidFolderClosed2",
                                            },
                                          }),
                                          _c(
                                            "PtTextTruncate",
                                            {
                                              attrs: { tag: "span", lines: 1 },
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getHighlightName(
                                                      data.folder_name
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm.service.isShowPatentCount
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "workspace_folder_tree__item__content-count",
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.kilo(
                                                          data.patent_count
                                                        )
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }